export const BANNER_MAINTENANCE = 'BANNER_MAINTENANCE'
export const SHOW_ALERT_ALGORITHM = 'SHOW_ALERT_ALGORITHM'
export const SHOW_INFO_MESSAGE_NOTEBOOK = 'SHOW_INFO_MESSAGE_NOTEBOOK'
export const RELATIVE_EMAIL = 'RELATIVE_EMAIL'
export const USER_LANGUAGE = 'userLanguage'
export const LOGOUT_REDIRECT_URL = 'onLogoutRedirectUrl'
